module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#ffffff",
      "margin": "0",
      "padding": "0.8em",
      "padding-left": "1.08em",
      "padding-top": "1.28em",
      "border-bottom": "none",
      "border": "none"
    }
  }, [_c('li', {
    staticClass: "header-left-2",
    staticStyle: {
      "min-width": "60%",
      "max-width": "65%"
    }
  }, [(_vm.can_show_back_nav) ? _c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "text-transform": "capitalize",
      "font-size": "18px",
      "font-weight": "bolder",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "0px",
      "margin-top": "-1.52em",
      "padding-top": "0",
      "display": "block"
    },
    attrs: {
      "id": "appName"
    }
  }, [(_vm.headerdata.name && (_vm.headerdata.name != '')) ? _c('span', [_vm._v(_vm._s(_vm.headerdata.name))]) : _c('span', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "font-size": "20px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.app_name))])])])]), _vm._v(" "), (_vm.can_show_side_nav) ? _c('li', {
    staticClass: "header-right-2",
    staticStyle: {
      "padding-top": "0.81em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "50%",
      "color": "#000000",
      "cursor": "pointer",
      "margin-top": "-0.9em",
      "padding": "5px 8px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-search",
    staticStyle: {
      "font-size": "1.28em",
      "color": "#5703a5"
    }
  })])]), _vm._v(" "), _c('li', [_c('component-account-menu')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd93932e"}!./src/pages/MainHeader/template.html
// module id = 624
// module chunks = 0